import { render, staticRenderFns } from "./DossierUpdateServicesStatuses.vue?vue&type=template&id=6e688d3a&"
import script from "./DossierUpdateServicesStatuses.vue?vue&type=script&lang=js&"
export * from "./DossierUpdateServicesStatuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports